import { render, staticRenderFns } from "./MediaBoxes.vue?vue&type=template&id=00704d83&"
import script from "./MediaBoxes.vue?vue&type=script&lang=js&"
export * from "./MediaBoxes.vue?vue&type=script&lang=js&"
import style0 from "./MediaBoxes.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports